export enum RaverState {
  ENTERING = 'ENTERING',
  FINDING_SPOT = 'FINDING_SPOT',
  DANCING = 'DANCING',
  THIRSTY = 'THIRSTY',
  GOING_TO_BAR = 'GOING_TO_BAR',
  DRINKING = 'DRINKING',
  RETURNING = 'RETURNING',
  LEAVING = 'LEAVING',
}

export interface RaverContext {
  hasTarget: boolean;
  atTarget: boolean;
  satisfaction: number;
  thirst: number;       // 0-1, increases over time
  nearBar: boolean;
  atBar: boolean;
}

const THIRST_THRESHOLD = 0.7;
const LEAVE_SATISFACTION_THRESHOLD = 0.1;

/**
 * Finite state machine for raver behavior.
 * Pure logic, no Phaser dependency.
 */
export class RaverAI {
  state: RaverState = RaverState.ENTERING;

  update(ctx: RaverContext): void {
    switch (this.state) {
      case RaverState.ENTERING:
        if (ctx.hasTarget) {
          this.state = RaverState.FINDING_SPOT;
        }
        break;

      case RaverState.FINDING_SPOT:
        if (ctx.atTarget) {
          this.state = RaverState.DANCING;
        }
        break;

      case RaverState.DANCING:
        if (ctx.satisfaction < LEAVE_SATISFACTION_THRESHOLD) {
          this.state = RaverState.LEAVING;
        } else if (ctx.thirst >= THIRST_THRESHOLD) {
          this.state = RaverState.THIRSTY;
        }
        break;

      case RaverState.THIRSTY:
        this.state = RaverState.GOING_TO_BAR;
        break;

      case RaverState.GOING_TO_BAR:
        if (ctx.atBar) {
          this.state = RaverState.DRINKING;
        }
        break;

      case RaverState.DRINKING:
        if (ctx.thirst <= 0) {
          this.state = RaverState.RETURNING;
        }
        break;

      case RaverState.RETURNING:
        if (ctx.atTarget) {
          this.state = RaverState.DANCING;
        }
        break;

      case RaverState.LEAVING:
        // Terminal state - raver will be despawned by CrowdManager
        break;
    }
  }
}
